import React from 'react';
import './ZoomSettings.scss';
import ReactSwitch from 'react-switch';

interface ZoomSettingsProps {
    currentZoom: number;
    markerVisibilityZoom: number;
    setMarkerVisibilityZoom: (zoom: number | null) => void;
    isIdNdaSigned: boolean;
    setIsIdNdaSigned: (value: boolean) => void;
    isMockPositionEnabled: boolean;
    setIsMockPositionEnabled: (value: boolean) => void;
}

const ZoomSettings = (props: ZoomSettingsProps) => {
    return (
        <div className="lanscape-map-zoom-container">
            <div className="current-zoom">
                Current Zoom: {props.currentZoom}
            </div>
            <div className="markers-visibility-settings">
                <div className="id-nda-signed-switcher">
                    <label>Mocked Positions Active</label>
                    <ReactSwitch
                        offColor="#d92550"
                        checked={props.isMockPositionEnabled}
                        onChange={(value) => {
                            props.setIsMockPositionEnabled(value);
                        }}
                        height={22}
                    />
                </div>
                <div className="id-nda-signed-switcher">
                    <label>Is ID NDA Signed</label>
                    <ReactSwitch
                        offColor="#d92550"
                        checked={props.isIdNdaSigned}
                        onChange={(value) => {
                            props.setIsIdNdaSigned(value);
                        }}
                        height={22}
                    />
                </div>
                <div className="set-current-zoom">
                    <div className="set-current-zoom-text">
                        Marks Visibility Zoom Limit
                    </div>
                    <div className="set-current-zoom-input">
                        <input
                            title="Enter"
                            type="number"
                            className="form-control"
                            defaultValue={props.markerVisibilityZoom}
                            onKeyDown={(event) => {
                                if (
                                    !/[0-9]/.test(event.key) &&
                                    event.key !== 'Backspace'
                                ) {
                                    event.preventDefault();
                                }
                            }}
                            onChange={(val) => {
                                if (val.target.value === '') {
                                    props.setMarkerVisibilityZoom(null);
                                } else {
                                    props.setMarkerVisibilityZoom(
                                        Number(val.target.value)
                                    );
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ZoomSettings;
